/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  Voucher,
  VoucherBulk,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    VoucherFromJSON,
    VoucherToJSON,
    VoucherBulkFromJSON,
    VoucherBulkToJSON,
} from '../models';

export interface BulkCreateVouchersRequest {
    xApplicationScope: ApplicationScope;
    voucherBulk: VoucherBulk;
}

export interface CreateVoucherRequest {
    xApplicationScope: ApplicationScope;
    voucher: Voucher;
}

export interface DeleteVoucherRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface GetVoucherRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface GetVouchersRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetVouchersAsExcelRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetVouchersForOrganisationRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetVouchersForOrganisationAsExcelRequest {
    xApplicationScope: ApplicationScope;
}

export interface PartiallyUpdateVoucherRequest {
    xApplicationScope: ApplicationScope;
    voucher: Voucher;
}

/**
 * 
 */
export class VoucherControllerApi extends runtime.BaseAPI {

    /**
     * bulk create vouchers
     * bulk create vouchers
     */
    async bulkCreateVouchersRaw(requestParameters: BulkCreateVouchersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Voucher>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling bulkCreateVouchers.');
        }

        if (requestParameters.voucherBulk === null || requestParameters.voucherBulk === undefined) {
            throw new runtime.RequiredError('voucherBulk','Required parameter requestParameters.voucherBulk was null or undefined when calling bulkCreateVouchers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vouchers/bulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VoucherBulkToJSON(requestParameters.voucherBulk),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VoucherFromJSON));
    }

    /**
     * bulk create vouchers
     * bulk create vouchers
     */
    async bulkCreateVouchers(requestParameters: BulkCreateVouchersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Voucher>> {
        const response = await this.bulkCreateVouchersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create a voucher
     * create a voucher
     */
    async createVoucherRaw(requestParameters: CreateVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Voucher>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createVoucher.');
        }

        if (requestParameters.voucher === null || requestParameters.voucher === undefined) {
            throw new runtime.RequiredError('voucher','Required parameter requestParameters.voucher was null or undefined when calling createVoucher.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vouchers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VoucherToJSON(requestParameters.voucher),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherFromJSON(jsonValue));
    }

    /**
     * create a voucher
     * create a voucher
     */
    async createVoucher(requestParameters: CreateVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Voucher> {
        const response = await this.createVoucherRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete a voucher
     * delete a voucher
     */
    async deleteVoucherRaw(requestParameters: DeleteVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteVoucher.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteVoucher.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vouchers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete a voucher
     * delete a voucher
     */
    async deleteVoucher(requestParameters: DeleteVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteVoucherRaw(requestParameters, initOverrides);
    }

    /**
     * get a voucher
     * get a voucher
     */
    async getVoucherRaw(requestParameters: GetVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Voucher>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getVoucher.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getVoucher.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vouchers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherFromJSON(jsonValue));
    }

    /**
     * get a voucher
     * get a voucher
     */
    async getVoucher(requestParameters: GetVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Voucher> {
        const response = await this.getVoucherRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all vouchers
     * get all vouchers
     */
    async getVouchersRaw(requestParameters: GetVouchersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Voucher>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getVouchers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vouchers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VoucherFromJSON));
    }

    /**
     * get all vouchers
     * get all vouchers
     */
    async getVouchers(requestParameters: GetVouchersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Voucher>> {
        const response = await this.getVouchersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all vouchers as excel file
     * get all vouchers as excel file
     */
    async getVouchersAsExcelRaw(requestParameters: GetVouchersAsExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getVouchersAsExcel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vouchers/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get all vouchers as excel file
     * get all vouchers as excel file
     */
    async getVouchersAsExcel(requestParameters: GetVouchersAsExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getVouchersAsExcelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all vouchers for organisation
     * get all vouchers for organisation
     */
    async getVouchersForOrganisationRaw(requestParameters: GetVouchersForOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Voucher>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getVouchersForOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vouchers/organisation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VoucherFromJSON));
    }

    /**
     * get all vouchers for organisation
     * get all vouchers for organisation
     */
    async getVouchersForOrganisation(requestParameters: GetVouchersForOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Voucher>> {
        const response = await this.getVouchersForOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all vouchers for an organisation as excel file
     * get all vouchers for an organisation as excel file
     */
    async getVouchersForOrganisationAsExcelRaw(requestParameters: GetVouchersForOrganisationAsExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getVouchersForOrganisationAsExcel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vouchers/organisation/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get all vouchers for an organisation as excel file
     * get all vouchers for an organisation as excel file
     */
    async getVouchersForOrganisationAsExcel(requestParameters: GetVouchersForOrganisationAsExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getVouchersForOrganisationAsExcelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * partially update a voucher
     * partially update a voucher
     */
    async partiallyUpdateVoucherRaw(requestParameters: PartiallyUpdateVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Voucher>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling partiallyUpdateVoucher.');
        }

        if (requestParameters.voucher === null || requestParameters.voucher === undefined) {
            throw new runtime.RequiredError('voucher','Required parameter requestParameters.voucher was null or undefined when calling partiallyUpdateVoucher.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vouchers`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VoucherToJSON(requestParameters.voucher),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherFromJSON(jsonValue));
    }

    /**
     * partially update a voucher
     * partially update a voucher
     */
    async partiallyUpdateVoucher(requestParameters: PartiallyUpdateVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Voucher> {
        const response = await this.partiallyUpdateVoucherRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
